import React, { FC, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { dashboardQueryClient } from '../../clients/ReactQueryClients/ReactQueryClients';
import useDetermineCompanyId from '../../hooks/useDetermineCompanyId';
import { useDashboardSelection } from './hooks';

interface Props {}

export const DashboardDefault: FC<Props> = (props: Props) => {
  const { t } = useTranslation();
  const companyId = useDetermineCompanyId();
  const { useDashboards } = dashboardQueryClient;
  const dashboardsQuery = useDashboards(companyId ?? undefined);
  const { handleSelectDefaultDashboard } = useDashboardSelection(companyId);

  useEffect(() => {
    if (dashboardsQuery.data === undefined) {
      return;
    }

    handleSelectDefaultDashboard(dashboardsQuery.data);
  }, [dashboardsQuery.data, handleSelectDefaultDashboard]);

  if (dashboardsQuery.isLoading) {
    return <div>{t('dashboard_loading', 'Loading...')}</div>;
  }

  if (dashboardsQuery.isError) {
    return (
      <div>
        {t(
          'dashboards_load_error',
          'Unable to load dashboards. Open the dashboards page and try again.'
        )}
      </div>
    );
  }

  return <div>{t('dashboard_redirecting', 'Redirecting...')}</div>;
};
